import styled from 'vue-styled-components';
import theme from '@/config/theme';

export const ProgressBar = styled.ol`
  display: flex;
  justify-content: space-between;
  list-style: none;
  padding: 0;
  margin: 0 0 1rem 0;

  li {
    flex: 2;
    position: relative;
    padding: 0 0 14px 0;
    font-size: 0.875rem;
    line-height: 1.5;
    color: ${theme.colors.primaryBlue};
    font-weight: 600;
    white-space: nowrap;
    overflow: visible;
    min-width: 0;
    text-align: center;
    border-bottom: 2px solid #e8e8e8;

    &:first-child,
    &:last-child {
      flex: 1;
    }

    &:last-child {
      text-align: right;
    }

    &::before {
      content: "";
      display: block;
      width: 8px;
      height: 8px;
      background-color: #e8e8e8;
      border-radius: 50%;
      border: 2px solid #fff;
      position: absolute;
      left: calc(50% - 6px);
      bottom: -7px;
      z-index: 3;
      transition: all 0.2s ease-in-out;
    }

    &:first-child::before {
      left: 0;
    }

    &:last-child::before {
      right: 0;
      left: auto;
    }

    &:not(.is-active) span {
      opacity: 0;
    }

    &:first-child span {
      display: inline-block;
      position: absolute;
      left: 0;
    }

    &:last-child span {
      width: 200%;
      display: inline-block;
      position: absolute;
      left: -100%;
    }
  }

  span {
    transition: opacity 0.3s ease-in-out;
    user-select: none;
  }

  .is-complete:not(:first-child)::after,
  .is-active:not(:first-child)::after {
    content: "";
    display: block;
    width: 100%;
    position: absolute;
    bottom: -2px;
    left: -50%;
    z-index: 2;
    border-bottom: 2px solid ${theme.colors.primaryBlue};
  }

  .is-complete:last-child::after,
  .is-active:last-child::after {
    width: 200%;
    left: -100%;
  }

  .is-complete::before {
    background-color: ${theme.colors.primaryBlue};
  }

  .is-active::before,
  li:hover::before {
    background-color: #fff;
    border-color: ${theme.colors.primaryBlue};
  }
  li:hover::before {
    transform: scale(1.33);
  }

  li:hover span {
    opacity: 1;
  }

  &:hover li:not(:hover) span {
    opacity: 0;
  }

  &.is-hover {
    .is-active::before,
    li:hover::before {
      cursor: pointer;
    }
  }
`;
